/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */

import { StrictMode } from 'react';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
// import axios from "axios";
import App from './app/App';
import './index.scss'; // Standard version
// import "./sass/style.react.rtl.css"; // RTL version
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'socicon/css/socicon.css';
import './_metronic/_assets/plugins/flaticon/flaticon.css';
import './_metronic/_assets/plugins/flaticon2/flaticon.css';
import './_metronic/_assets/plugins/keenthemes-icons/font/ki.css';
// Datepicker
import 'react-datepicker/dist/react-datepicker.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { RecoilRoot } from 'recoil';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { ApolloWrapper } from './api/apollo-appsync/ApolloWrapper';
import { store } from './app/store';
import { initializeMixpanel } from './common/userTracking';
import { MetronicI18nProvider } from './_metronic/i18n';
import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider,
} from './_metronic/layout';

const persistor = persistStore(store);

initializeMixpanel();

// import { ReactQueryDevtools } from 'react-query/devtools';

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { VITE_APP_PUBLIC_URL } = process.env;

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/* const mock = */

// Create a client
const queryClient = new QueryClient();

/**
 * Inject metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
ReactDOM.render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <MetronicI18nProvider>
          <RecoilRoot>
            <QueryClientProvider client={queryClient}>
              <ApolloWrapper>
                <MetronicLayoutProvider>
                  <MetronicSubheaderProvider>
                    <MetronicSplashScreenProvider>
                      <App basename={VITE_APP_PUBLIC_URL} />
                    </MetronicSplashScreenProvider>
                  </MetronicSubheaderProvider>
                </MetronicLayoutProvider>
                {/* <ReactQueryDevtools initialIsOpen={false} /> */}
              </ApolloWrapper>
            </QueryClientProvider>
          </RecoilRoot>
        </MetronicI18nProvider>
      </PersistGate>
    </Provider>
  </StrictMode>,
  document.getElementById('root')
);
